<template>
  <div>
    <div class="l-row">
      <div class="l-col-12@md">
        <product-price :input="variation.price" :block="disabledInputs" :module="fromModule" :sku="variation.sku" v-if="!useUniquePrice"/>
      </div>
    </div>
    <div class="l-row">
      <div class="l-col-3@md">
        <form-group label="Redutor" :columns="12" :error="getError('stock.reducer', variation.sku)" :required="true">
          <input class="form-input" type="number" min="0" v-model="variation.stock.reducer" :disabled="disabledInputs">
        </form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import FormGroup from '@/components/template/FormGroup'
import ProductPrice from '@/components/shared/ProductPrice'

export default {
  props: {
    variation: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    productId: {
      type: String
    }
  },
  computed: {
    ...mapGetters('errors', [
      'getError'
    ]),
    ...mapFields({
      loading: 'editPrices.loading'
    }),
    ...mapGetters('editPrices', [
      'isUseUniquePrice'
    ]),
    useUniquePrice () {
      return this.isUseUniquePrice(this.productId)
    },
    disabledInputs () {
      return this.variation.status === 'sent' || this.variation.status === 'error'
    }
  },
  components: {
    FormGroup,
    ProductPrice
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VariationAttributes.vue?7b4d3a89